// @flow

import React from 'react'
import { connect } from 'react-redux'
import { customerSort } from '../../helpers'
import { selectCustomers } from '../../stores/customersStore'
import OpinarySelect from '../Controls/OpinarySelect'

type Customer = {
  id: string,
  name: string,
  label: string,
  brand: boolean,
  country: string,
  language: string,
}

type Props = {
  onChange: Function,
  customers: Array<Customer>,
  customerId: string,
  placeholder: string,
  disabled: boolean,
  clearable: boolean,
  className: string,
  colorClass: string,
}

export function CustomerSelect({
  onChange,
  customers,
  customerId = '',
  placeholder = 'Select a customer',
  disabled = false,
  clearable = true,
  className,
  colorClass,
}: Props) {
  const sortedCustomers = customers.slice().sort(customerSort)
  return (
    <OpinarySelect
      className={`${className}`}
      colorClass={colorClass}
      value={customerId}
      placeholder={placeholder}
      options={sortedCustomers}
      disabled={disabled}
      clearable={clearable}
      onChange={onChange}
    />
  )
}

function toOption(customer) {
  return {
    label: customer.name,
    value: customer.id,
  }
}

export default connect(state => ({
  customers: selectCustomers(state).map(toOption),
}))(CustomerSelect)



// WEBPACK FOOTER //
// ./src/components/CustomerSelect/index.js